import {service,downloadService} from './axios'
import qs from 'qs'
import { Message } from "element-ui";
import {getToken} from "./auth";

export function get(url, data = {}, timeout = 200*1000) {
    return new Promise((resolve, reject) => {
        service.get(url, {
          params: data,
          timeout: timeout
        }).then(response => {
            if (response.data) {
                return resolve(response.data)
            }
            return reject("none")
        }).catch(err => {
            reject(err)
        })
    })
}

export async function post(url, data = {},
                           headers= {'Content-Type': 'application/x-www-form-urlencoded'},
                           raw= false,
                           timeout= 300*1000) {
    if (!raw) {
        data = qs.stringify(data);
    }

    return new Promise((resolve, reject) => {
        service.post(url, data, {
          headers: headers,
          timeout: timeout
        })
            .then(response => {
                if (response.data) {
                    return resolve(response.data)
                }
                return reject("none")
            })
            .catch(err => {
                reject(err)
            })
    })
}

export async function download(url,data = {}) {
  let token = getToken();
  data = qs.stringify(data);
  downloadService
    .post(
      url,data, {
        responseType:'blob',
        headers:{
          'fdz-token' : token
        }
      })
    .then(response=>{
      if (!response){
        return;
      }
      let filename = response.headers['content-disposition'].split("=")[1];
      let blob = new Blob([response.data], {type: 'application/vnd.ms-excel'});
      let url = window.URL.createObjectURL(blob);
      let aLink = document.createElement("a");
      aLink.style.display = "none";
      aLink.download = decodeURIComponent(filename);
      console.log('filename', filename);
      aLink.href = url;
      console.log('url',url);
      document.body.appendChild(aLink);
      aLink.click()
    })
    .catch(err=>{
      Message.error('下载出错');
      console.log(err);
    })
}



// WEBPACK FOOTER //
// ./src/utils/http.js